import AppHeader from '../AppHeader'

export default {
  name: 'master-category-new',
  created () {
  },
  data () {
    return {
      canValidate: true,
      name: '',
      name_hurigana: '',
      isSaving: false
    }
  },
  computed: {
    authToken () {
      return window.localStorage.getItem('access_token')
    },
    validation () {
      let hiragana = /^[\u3040-\u309fー]+$/

      const validation = {
        name: !!this.name,
        name_hurigana: !!this.name_hurigana && hiragana.test(this.name_hurigana)
      }
      return validation
    },
    validationAll () {
      if (!this.validation.name) return false
      if (!this.validation.name_hurigana) return false
      return true
    }
  },
  components: {
    AppHeader
  },
  methods: {
    async onClickSave () {
      // 連打対応
      if (this.isSaving) return false
      this.isSaving = true

      // 保存処理
      await this.$store.dispatch('CREATE_MASTER_CATEGORY', {
        data: {
          name: this.name,
          name_hurigana: this.name_hurigana
        }
      })
      .catch(err => {
        console.error(err)
        return
      })

      // カテゴリー一覧へ戻る
      this.$router.push('/master_category_list')
    },
    onClickCancel () {
      this.$router.push('/master_category_list')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/master-category-new.js